import { render, staticRenderFns } from "./ViaEmilia.vue?vue&type=template&id=4abd0abc&"
import script from "./ViaEmilia.vue?vue&type=script&lang=js&"
export * from "./ViaEmilia.vue?vue&type=script&lang=js&"
import style0 from "./ViaEmilia.vue?vue&type=style&index=0&id=4abd0abc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports